import { render, staticRenderFns } from "./UsersPermissionGroupsUpdate.vue?vue&type=template&id=a04a3732"
import script from "./UsersPermissionGroupsUpdate.vue?vue&type=script&lang=js"
export * from "./UsersPermissionGroupsUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports